module.exports = __webpack_public_path__ + "static/media/Location_Book-Gilded_District.aa4c8cff.png";